/** @format */

import styled from 'styled-components';
import { breakpointFrom } from '../../theme/mixins';

export const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
  display: grid;
  place-items: center;

  & > * {
    grid-area: 1 / 1;
  }
`;

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  --top: clamp(2.5rem, 2.4071rem + 0.381vw, 2.75rem);
  --inline-padding: clamp(0.94rem, -0.0109rem + 3.901vw, 3.5rem);
  display: grid;
  align-content: start;
  position: absolute;
  inset: 0;
  background: ${({ theme }) => theme.color.teal.dark};
  padding-block: var(--top) 3.75rem;
  padding-inline: var(--inline-padding);

  p {
    color: ${({ theme }) => theme.color.white};
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.3125rem; /* 131.25% */
    letter-spacing: 0.03rem;
    white-space: pre-line;
  }
  h4 {
    color: ${({ theme }) => theme.color.white};
  }
  p + h4 {
    margin-top: 1.75em;
  }
  h3,
  h3 + p {
    color: ${({ theme }) => theme.color.yellow};
    max-width: 85%;
  }

  ${breakpointFrom.lg`
    max-width: 60rem;
    max-height: 36rem;
    margin: auto;
  `}
`;

export const IconButton = styled.button`
  border: none;
  background: none;
  position: absolute;
  top: var(--top);
  right: calc(var(--inline-padding) + 1.5rem - 0.94rem);
  cursor: pointer;
`;

export const WrapperScroll = styled.div`
  overflow-y: auto;
  margin-top: 2.75rem;
  margin-right: calc(2.19rem - 0.94rem);
  padding-right: 1.5rem;

  & > * {
    max-width: 47rem;
  }

  /* ===== Scrollbar CSS ===== */
  /* Variables */
  --scrollbar-color-thumb: ${({ theme }) => theme.color.yellow};
  --scrollbar-color-track: ${({ theme }) => theme.color.white};
  --scrollbar-border-radius: 54px;
  --scrollbar-width: 11px;

  /* Firefox */
  scrollbar-width: auto;
  scrollbar-color: var(--scrollbar-color-thumb) var(--scrollbar-color-track);

  /* Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    width: var(--scrollbar-width);
  }

  &::-webkit-scrollbar-track {
    background: var(--scrollbar-color-track);
    border-radius: var(--scrollbar-border-radius);
  }

  &::-webkit-scrollbar-thumb {
    background: var(--scrollbar-color-thumb);
    border-radius: var(--scrollbar-border-radius);
  }

  a {
    display: inline-block;
    margin-top: 1.75rem;
  }
`;
